/**
 * Creates a debounced function. Defined at module scope to avoid nested
 * function declarations inside React effects (Sonar S2004).
 */
export const debounceResize = <T extends (...args: any[]) => void>(fn: T, delay: number) => {
    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    return (...args: Parameters<T>) => {
        if (timeoutId !== undefined) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(() => fn(...args), delay);
    };
};

export const normalizeSearchText = (text: string) =>
    text
        .toLowerCase()
        .replace(/ı/g, 'i')
        .replace(/i̇/g, 'i')
        .replace(/ğ/g, 'g')
        .replace(/ü/g, 'u')
        .replace(/ş/g, 's')
        .replace(/ö/g, 'o')
        .replace(/ç/g, 'c');

export const filterHeaderMenuByQuery = (menuList: any[], query: string) => {
    const searchQuery = normalizeSearchText(query);

    return menuList
        .map((menuItem: any) => {
            const matchingSubMenus =
                menuItem.items?.menuItem?.filter((subItem: any) =>
                    normalizeSearchText(subItem.text).includes(searchQuery)
                ) || [];

            if (matchingSubMenus.length === 0) {
                return null;
            }

            return {
                ...menuItem,
                items: {
                    ...menuItem.items,
                    menuItem: matchingSubMenus,
                },
            };
        })
        .filter(Boolean);
};
